
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LeftTurn extends Vue {

    @Prop({required: false})
    circling!: boolean;

    @Prop({required: false})
    extendEnd!: boolean;

    @Prop({required: false})
    returnLevel!: number;



    pageWidth = 0;
   
    created() {
        window.addEventListener("resize", this.windowEventHandler);
    }

    destroyed() {
        window.removeEventListener("resize", this.windowEventHandler);
    }

    public windowEventHandler() {
        let fraction = 20 
        if(this.extendEnd) fraction = 10
        this.pageWidth = (document.documentElement.clientWidth-1700)/fraction
        if(this.pageWidth<0)this.pageWidth=0;
        var extendedTrail = document.getElementById('extended-trail-'+this.returnLevel);
        if(extendedTrail)
            extendedTrail.style.setProperty('--extendedtraillength', this.pageWidth+'px')
    }

    mounted(){
        this.windowEventHandler()
    }

}
